import { SET_GLOBAL_SITE, SET_GLOBAL_COMPANY } from 'fixtures/actions'

const setGlobalSite = payload => dispatch => {
  dispatch({
    type: SET_GLOBAL_SITE,
    payload
  })

  dispatch({
    type: SET_GLOBAL_COMPANY,
    payload: null
  })
}

const setGlobalCompany = payload => dispatch => {
  dispatch({
    type: SET_GLOBAL_COMPANY,
    payload
  })
}

export {
  setGlobalSite,
  setGlobalCompany
}
